export const navigation = {
	header: {
		title: "All categories",
		searchTooltip: "Search categories",
		addCategoryTooltip: "Add category",
		showZeroProductCategoriesTooltip: "Show categories with no products",
		hideZeroProductCategoriesTooltip: "Hide categories with no products",
		showEmptyCategories: "Show categories with no products",
		hideEmptyCategories: "Hide categories with no products",
		show: "Show",
		hide: "Hide",
	},
	search: {
		placeholder: "Search category",
		closeTooltip: "Close search",
	},
	subcategories: {
		levelPrefix: "Priority",
	},
	priorityLabel: "Priority",
	categoryDisabledTooltip: "Cannot add products to this category",
	loadingCategories: "Loading categories",
	emptyState: {
		noSearchResults: {
			title: "No categories found",
			message: "We didn't find categories that match your search for",
		},
		noCategories: {
			title: "No categories found",
			message: "There are no categories with linked products",
		},
		noCategoriesWithFilters: {
			title: "No categories found",
			message:
				"There are no categories that match the applied filters",
		},
		clearSearchButton: "Clear search",
		clearFiltersButton: "Clear filters",
		createCategoryButton: "Create category",
		showHiddenCategoriesButton: "Show categories",
	},
};
